// extracted by mini-css-extract-plugin
export default {"deleteButton":"_2Jj8KG9tKCdbGO471B6Rv8","focus-visible":"c8x6glFxMIY3k5CrvueW2"};